import React from 'react';
import { Table, Button, Select, Row, Col, Space } from 'antd';
import { FileAddOutlined, SafetyOutlined, ToolOutlined, AuditOutlined, ClockCircleOutlined, CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Fade } from 'react-reveal';
import { useReembolsosPage } from './useReembolsosPage';
import ModalCrear from './crear/ModalCrear';

const ESTATUS_REEMBOLSO = [
  { label: <><SafetyOutlined /> Calidad</>,               value: 1 },
  { label: <><ToolOutlined /> Operaciones</>,             value: 2 },
  { label: <><AuditOutlined /> Dirección</>,              value: 3 },
  { label: <><ClockCircleOutlined /> Esperando Pago</>,   value: 4 },
  { label: <><CheckCircleOutlined /> Pagado</>,           value: 5 },
  { label: <><CloseCircleOutlined /> Rechazados</>,       value: 10 },
];

export default function Reembolsos() {
  const { reembolsos, loading, columns, estatus, setEstatus, modalCrear, setModalCrear, form, handleOk, handleCancelModal } = useReembolsosPage();

  return (
    <Fade>
      <div className="pagos-v2 pagos-v2__container">
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <div className="card__titulo">Reembolsos</div>

        <Row justify="space-between">
          <Col><Select options={ESTATUS_REEMBOLSO} value={estatus} onChange={setEstatus} style={{ width: 160 }} /></Col>
          {/* <Col><Button type="primary" icon={<FileAddOutlined />} onClick={() => setModalCrear(true)}>Crear Reembolso</Button></Col> */}
        </Row>

        <Table
          size="small"
          rowKey="reembolsoID"
          dataSource={reembolsos}
          columns={columns}
          loading={loading}
          pagination={{ showTotal: (t) => `${t} registros`, showSizeChanger: true, position: ['bottomCenter'] }}
        />

        <ModalCrear open={modalCrear} form={form} onOk={handleOk} onCancel={handleCancelModal} />
      </Space>
      </div>
    </Fade>
  );
}